import { createSelector } from 'reselect';
import { setAsessments } from 'utils/data';

const getSectorSelected = (state) => state.data.filters.sector;
const getCountryCategory = (state) => state.data.filters.countryCategory;
const getGroup = (state) => state.data.filters.region;
const getCountriesList = (state) => state.countryProfile.countries;
const getData = (state) => state.data.data[state.data.filters.country];
const getSort = (state) => state.data.sort;
const getFilters = (state) => state.data.filters;
const getCountrySectors = (state) => state.data.countrySectors;
const getPublicationsAndData = (state) => state.publicationsAndData.list;

const sortBy = (list, type) => {
  if (list.length) {
    const listNulls = list.filter((l) => !l[type]);
    const listValues = list.filter((l) => !!l[type]);
    const sortedListValues = listValues.slice().sort((a, b) => {
      if (typeof listValues[0][type] === 'string') {
        if (isNaN(a[type]) || isNaN(b[type])) {
          const x = a[type].toLowerCase();
          const y = b[type].toLowerCase();
          if (x < y) return -1;
          if (x > y) return 1;
          return 0;
        }
        parseFloat(b[type]) - parseFloat(a[type]);
      }
      return b[type] - a[type];
    });
    return [...sortedListValues, ...listNulls];
  }
  return list;
};

const sortList = (sort, list) => {
  let sortedlist = [];
  const nullList = [];
  sortBy(list, sort.type).forEach((l) => {
    const isScoreNull =
      Object.keys(l)
        .filter((el) => el.startsWith('score'))
        .filter((s) => l[s] !== null).length === 0;
    if (isScoreNull) {
      nullList.push(l);
    } else sortedlist.unshift(l);
  });
  sortedlist = sort.direction === 'asc' ? sortedlist : sortedlist.reverse();
  sortedlist = sortedlist.concat(nullList);
  return sortedlist;
};

export const filterData = createSelector(
  [getSectorSelected, getCountriesList, getCountrySectors, getFilters, getSort, getGroup],
  (sector, data, countrySectors, filters, sort, region) => {
    let filtered = [];

    const filterFunction = (t) => {
      let regionFilter = false;
      let sectorFiler = false;

      if (region && region !== '') {
        regionFilter = (region === 'global') || t.region.includes(region);
      }

      if (sector && sector !== '') {
        sectorFiler = (sector === 'both') || t.sector === sector;
      }

      return regionFilter && sectorFiler;
    };
    if (filters.category === '') {
      filtered = setAsessments(data).filter(filterFunction);
    } else {
      const countriesIso = data ? data.map(el => el.iso) : [];
      if (countriesIso.length) {
        filtered = countrySectors.filter(el => countriesIso.includes(el.iso)).filter(filterFunction);
      } else {
        filtered = countrySectors.filter(filterFunction);
      }
    }

    if (filtered.length) filtered = sortList(sort, filtered);
    return filtered;
  }
);

export const filterDataCountry = createSelector(
  [getSectorSelected, getCountryCategory, getData],
  (sector, category, data) => {
    if (!data) return false;
    if (category) {
      if (sector !== 'both') {
        return {
          ...data,
          questions: data.questions.filter((t) => t.category === category && t.sector === sector)
        };
      }
      return {
        ...data,
        questions: data.questions.filter((t) => t.category === category)
      };
    } else if (sector !== 'both') {
      return {
        ...data,
        questions: data.questions.filter((t) => t.sector === sector)
      };
    }
    return data;
  }
);

export const getDownloadGeneralLink = createSelector(
  [getPublicationsAndData],
  (publicationsAndDataArr) => {
    const globalIndex = Object.keys(publicationsAndDataArr).find(key => publicationsAndDataArr[key].slug === 'downloads');
    return globalIndex !== undefined && publicationsAndDataArr[globalIndex].documents.length ?
     config.apiHost + publicationsAndDataArr[globalIndex].documents[0].document : '';
  });



// WEBPACK FOOTER //
// ./app/selectors/data.js